import script from "./CurrentLocation.vue?vue&type=script&setup=true&lang=js"
export * from "./CurrentLocation.vue?vue&type=script&setup=true&lang=js"

import "./CurrentLocation.vue?vue&type=style&index=0&id=248d52ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-248d52ba"]])

export default __exports__